import { Head, Link } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { Heading } from '@/components/ui/heading';
import { PublicLayout } from '@/components/public/PublicLayout';

const PublicNotFound = () => {
  return (
    <PublicLayout>
      <Head title="Pagina non trovata">
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <section className="py-24">
        <div className="container">
          <div className="max-w-xl mx-auto text-center">
            <Heading level={1} align="center" className="mb-4">
              404
            </Heading>
            <p className="text-muted-foreground mb-8">
              La pagina che stai cercando non esiste o è stata spostata.
            </p>
            <Button asChild>
              <Link href="/">Torna alla home</Link>
            </Button>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
};

export default PublicNotFound;
